import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  company: {},
  twoFactorAuthConfig: {},
}

export const mutations = {
  SET_COMPANY(state, company) {
    state.company = company
  },
  SET_TWO_FACTOR_AUTH_CONFIG(state, twoFactorAuthConfig) {
    state.twoFactorAuthConfig = twoFactorAuthConfig
  },
}

export const actions = {
  fetchCompany({ commit }, company_uuid) {
    return ApiService.fetchCompany(company_uuid)
      .then((res) => {
        const company = res.data
        commit('SET_COMPANY', company)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchTwoFactorAuthConfig({ commit }, company_uuid) {
    return ApiService.fetchTwoFactorAuthConfig(company_uuid)
      .then((res) => {
        const twoFactorAuthConfig = res.data
        commit('SET_TWO_FACTOR_AUTH_CONFIG', twoFactorAuthConfig)
      })
      .catch((error) => {
        throw error
      })
  },
  editTwoFactorAuthConfig({ commit }, payload) {
    return ApiService.editTwoFactorAuthConfig(payload)
      .then((res) => {
        const twoFactorAuthConfig = res.data
        commit('SET_TWO_FACTOR_AUTH_CONFIG', twoFactorAuthConfig)
      })
      .catch((error) => {
        throw error
      })
  },
  editCompany({ commit }, payload) {
    return ApiService.editCompany(payload)
      .then((res) => {
        const company = res.data
        commit('SET_COMPANY', company)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteCompanyLogo({ commit }, company_uuid) {
    return ApiService.deleteCompanyLogo(company_uuid)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
}
